import React from 'react';
import { PagePath, RowHeaderTable, TableDrivers } from '../../components';

const Drivers: React.FC = () => {
  return (
    <div className="container-body no-padding">
      <RowHeaderTable name="Motoristas" />
      <TableDrivers />
    </div>
  );
};

export default Drivers;
